import { Stack } from "@mui/material";
import {
  Button,
  useFoundationColorTokens,
  useSpacing,
} from "@surya-digital/leo-reactjs-material-ui";
import { Plus } from "lucide-react";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSurveyRuleStore } from "../../stores/Hooks";
import { useDetailSectionHeader } from "../../../../contexts/DetailSectionHeaderContext";

interface SurveyRuleActionButtonProps {}

export const SurveyRuleActionButton: React.FC<SurveyRuleActionButtonProps> =
  observer(() => {
    const [footerBottom, setFooterBottom] = useState(0);

    const { t } = useTranslation();
    const { subscribeToSectionOffset, detailsSectionRootContainerElement } =
      useDetailSectionHeader();
    const spacing = useSpacing();
    const tokens = useFoundationColorTokens();

    const surveyRuleStore = useSurveyRuleStore();

    useEffect(
      () => subscribeToSectionOffset(setFooterBottom),
      [subscribeToSectionOffset],
    );

    const handleAddNewRule = (type: "SINGLE" | "GROUP"): void => {
      surveyRuleStore.addNewRule(type);
      requestAnimationFrame(() => {
        detailsSectionRootContainerElement?.scrollTo({
          top: detailsSectionRootContainerElement.scrollHeight,
          behavior: "smooth",
        });
      });
    };

    return (
      <Stack
        direction="row"
        gap={spacing.spaceXS}
        position="sticky"
        bottom={footerBottom}
        bgcolor={tokens.backgroundElevatedLevel1}
        paddingBlock={spacing.spaceMD}
        paddingInline={spacing.space2XL}
        width="100%"
      >
        <Button
          label={t("surveys.rules.addRule")}
          name="addRule"
          onClick={() => handleAddNewRule("SINGLE")}
          size="medium"
          icon={<Plus />}
          variant="outlined-neutral"
        />
        <Button
          label={t("surveys.rules.addGroup")}
          name="addGroup"
          onClick={() => handleAddNewRule("GROUP")}
          size="medium"
          icon={<Plus />}
          variant="outlined-neutral"
        />
      </Stack>
    );
  });
